import React, { Component } from "react";
import styles from "../../assets/css/modules/shared/choose-button.css";
import { handleKeyPress } from "../../helpers/KeyPressHelper";

export default class ChooseButton extends Component {
  render() {
    return (
      <div
        className={
          (this.props.horizontal ? styles.horizontal : "") +
          " " +
          styles.chooseButton +
          " " +
          styles.buttonHeight +
          " " +
          (this.props.featureFlagEP !== true || this.props.selection ? "": styles.buttonNotSelected) + 
          " " +
          (this.props.selected ? styles.buttonSelected : "")
        }
        onClick={this.props.onClick}
        onKeyPress={(e) => {
          handleKeyPress(e, this.props.onClick);
        }}
      >
        {this.props.imgSrc && (
          <img src={this.props.imgSrc} alt="" aria-hidden />
        )}
        {this.props.icon && (
          <i className={this.props.icon + " " + styles.icon} />
        )}
        <p className={styles.title}>{this.props.title}</p>
        {this.props.description && (
          <p className={styles.description}>{this.props.description}</p>
        )}
        {this.props.children}
      </div>
    );
  }
}
